module.exports = function(list, pred) {
  var i, len, x;
  if (pred == null) {
    pred = function(a) {
      return a;
    };
  }
  for (i = 0, len = list.length; i < len; i++) {
    x = list[i];
    if (!pred(x)) {
      return false;
    }
  }
  return true;
};
